<script context="module">
  import { Client, getLanguage } from '../utils/prismicHelpers';

  export async function load({ session, error, status }) {
    const { LANGUAGE } = session;
    const doc = await Client().getSingle('faq', { lang: getLanguage(LANGUAGE) });

    if (doc) {
      return {
        props: {
          doc,
        },
      };
    } else {
      return {
        error,
        status,
      };
    }
  }
</script>

<script>
  import SliceZone from '../components/SliceZone.svelte';
  import CallToAction from '../components/CallToAction.svelte';
  import { _ } from 'svelte-i18n';
  import BookDemoWithButton from '../components/BookDemoWithButton.svelte';

  export let doc;
</script>

<svelte:head>
  <title>{$_('faq.title')} | {$_('common.title')}</title>
</svelte:head>

<SliceZone slices={doc.data.body} />

<CallToAction />

